import { useCallback, useContext, useEffect, useState } from 'react';
import ReportContext from '../../../contexts/ReportContext';
import PopupContext from '../../../contexts/PopupContext';
import BoardContext from '../../../contexts/BoardContext';
import DashboardContext from '../../../contexts/DashboardContext';

type TSource =
  | 'Popup Report'
  | 'Popup Board'
  | 'Dashboard'
  | 'Report'
  | 'Board'
  | 'NA';

const useLinkedFromSource = (): TSource => {
  const { report } = useContext(ReportContext);
  const { selectedBoard, selectedReport, isOpen } = useContext(PopupContext);
  const { board } = useContext(BoardContext);
  const { dashboard } = useContext(DashboardContext);

  const getSource = useCallback(() => {
    if (isOpen) {
      if (selectedReport) {
        return 'Popup Report';
      }
      if (selectedBoard) {
        return 'Popup Board';
      }
      return 'NA';
    }

    if (dashboard) {
      return 'Dashboard';
    }
    if (report) {
      return 'Report';
    }
    if (board) {
      return 'Board';
    }
    return 'NA';
  }, [board, dashboard, isOpen, report, selectedBoard, selectedReport]);
  const [source, setSource] = useState<TSource>(getSource());
  useEffect(() => {
    setSource(getSource());
  }, [getSource]);

  return source;
};

export default useLinkedFromSource;
